import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Output } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../../../../environments/environment';

@Injectable()
export class CustomerEditService {
    private urlPrefix: string = environment.appUrl;
    constructor(
        private http: Http,
        private httpClient: HttpClient
    ) {}

    edit(id, post): Observable<any> {
        const url = this.urlPrefix + 'customers/' + id ;
        if (post.loginEmail.value == ""){
            post.loginEmail.value = null;
        }
        return this.httpClient
            .put(url, {
                contactEmailOne: post.contactEmailOne.value,
                contactEmailTwo: post.contactEmailTwo.value,
                contactNumberOne: post.contactNumberOne.value,
                contactNumberTwo: post.contactNumberTwo.value,
                contactPersonOne: post.contactPersonOne.value,
                contactPersonTwo: post.contactPersonTwo.value,
                customerProjectContactNameOne: post.customerProjectContactNameOne.value,
                customerProjectContactNumberOne: post.customerProjectContactNumberOne.value,
                customerProjectContactEmailOne: post.customerProjectContactEmailOne.value,
                customerProjectContactNameTwo: post.customerProjectContactNameTwo.value,
                customerProjectContactNumberTwo: post.customerProjectContactNumberTwo.value,
                customerProjectContactEmailTwo: post.customerProjectContactEmailTwo.value,
                email: post.loginEmail.value,
                name: post.name.value,
                shortName: post.shortName.value,
            }, {
                observe: 'response'
            })
            .map(
                res => {
                    if (res.status === 201) {
                        return res.body;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/customer/customer-edit/customer-edit.service.ts